import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Divider, Typography, Stack, SvgIcon, Collapse } from '@mui/material'
import { ExpandMore, ExpandLess, CheckCircle } from '@mui/icons-material'
import { ReactComponent as personIcon } from '../../common/assets/icons/personIcon.svg'
import { DataDispatchContext } from '../../../contexts/data/dataContext'

function ReferralItem({ referral, isLastItem, isOpen, onToggle }: any) {
  const dispatch: any = useContext(DataDispatchContext)

  const navigate = useNavigate()

  function formatDate(dateString: any) {
    const date = new Date(dateString)
    const day = date.getUTCDate()
    const month = date.toLocaleString('default', { month: 'long' })
    const year = date.getUTCFullYear()

    return `${day} ${month} ${year}`
  }

  const handleReferralRewardClick = () => {
    dispatch({
      type: 'setAcctSelected',
      acctSelected: 'help',
    })
    navigate('/profile')
  }

  const successfulReferral = referral.status === 'success'

  function getDisplayStatus(status: any) {
    const statusMap = {
      enquired: 'New',
      inProgress: 'In progress referral',
      installationBooked: 'Installation booked',
      onboarding: 'Onboarding',
      notProgressing: 'Not progressing',
      notSuitable: 'Not suitable for solar',
      success: 'Successful',
      unknown: 'Unknown',
    }
    return statusMap[status as keyof typeof statusMap]
  }

  return (
    <Box>
      <Stack spacing={2} p={1.5} sx={{ justifyContent: 'space-between' }} direction="row" alignItems="center">
        <Stack spacing={1} direction="row" alignItems="center">
          <SvgIcon component={personIcon} inheritViewBox />
          <Typography variant="szBody.Regular.Small">{referral?.referralDetails?.name}</Typography>
        </Stack>
        <Stack spacing={1} direction="row" alignItems="center" sx={{ cursor: 'pointer' }} onClick={onToggle}>
          {successfulReferral && <CheckCircle sx={{ color: 'success.main', fontSize: 16 }} />}
          <Typography
            variant="szBody.Regular.Small"
            sx={{ color: successfulReferral ? 'success.main' : 'text.tertiary' }}>
            {getDisplayStatus(referral.status)}
          </Typography>
          <SvgIcon component={isOpen ? ExpandLess : ExpandMore} sx={{ color: 'text.tertiary' }} inheritViewBox />
        </Stack>
      </Stack>
      <Collapse in={isOpen}>
        <Box>
          <Stack spacing={2} p={1.5} sx={{ justifyContent: 'space-between' }}>
            <Typography variant="szBody.Regular.Small">{referral.message}</Typography>
            <Typography variant="szBody.Regular.Small" sx={{ color: 'text.tertiary' }}>
              As of {formatDate(referral.modifiedDate)}
            </Typography>
            {successfulReferral && (
              <Typography
                variant="szBody.Regular.Small"
                sx={{ color: '#006FF4', cursor: 'pointer' }}
                onClick={handleReferralRewardClick}>
                Haven’t received referral reward?
              </Typography>
            )}
          </Stack>
        </Box>
      </Collapse>
      {!isLastItem && <Divider />}
    </Box>
  )
}

export default ReferralItem
